module.exports = __webpack_public_path__ + "img/searchmobile.e953d143.svg";